import { eventDispatcher, TOPICS } from "@origin-digital/event-dispatcher";
import { getIntentRoute, Params } from "@origin-digital/mcapp-registry";
import { BackendCrm, Channel } from "@origin-digital/platform-enums";

export const getClickHandlerHelpSupportButton = (
  helpLink?: HelpLinkConfig,
  isNative?: boolean
) => {
  if (helpLink === undefined || helpLink === false) {
    return undefined;
  }

  const intent = "helpAndSupportDeepLink";

  const parameters = helpLink === true ? {} : (helpLink as Params);

  const nativeHandler = () =>
    eventDispatcher.dispatch({
      topic: TOPICS.NAV_TO,
      payload: {
        to: intent,
        parameters,
      },
    });

  const webHandler = () => {
    window.open(
      getIntentRoute(
        intent,
        {
          backends: [BackendCrm.KRAKEN],
          channel: Channel.WEB,
          scopedToken: false,
        },
        parameters
      ).url,
      "_blank"
    );
  };

  return isNative ? nativeHandler : webHandler;
};
